import React, { useEffect, useState } from "react";
import { Col, Dropdown, DropdownToggle } from "reactstrap";
import { useOffice } from "../../hook/useOffice";

const OfficeDropdown = () => {
  // Declare a new state variable, which we'll call "menu"
  const [selectedLang, setSelectedLang] = useState("");

  const { resetOffice, office } = useOffice();

  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
    setSelectedLang(currentLanguage);
  }, []);

  const [isOfficeDropdown, setIsOfficeDropdown] = useState(false);
  const toggleOfficeDropdown = () => {
    setIsOfficeDropdown(!isOfficeDropdown);
  };
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isOfficeDropdown}
        toggle={toggleOfficeDropdown}
        className="ms-1 topbar-head-dropdown header-item"
      >
        <DropdownToggle
          className="btn btn-ghost-primary  shadow-none"
          tag="button"
          onClick={() => resetOffice()}
          style={{
            backgroundColor: "#F3F3F8",
            marginLeft: "15px",
          }}
        >
          <Col>
            <span className="d-flex align-items-center">
              <i className="ri-building-4-fill fs-20 text-success"></i>
              <span className="text-start">
                <span
                  className="d-none d-xl-inline-block "
                  style={{
                    marginLeft: "8px",
                  }}
                >
                  <span className="d-none d-xl-inline-block fs-10 ms-1 fw-medium user-name-text">
                    Escritório selecionado
                  </span>
                  <span className="d-none d-xl-block ms-1 fs-10 text-muted user-name-sub-text">
                    {office ? office.name : "-"}
                  </span>
                </span>
              </span>
            </span>
          </Col>
        </DropdownToggle>
      </Dropdown>
    </React.Fragment>
  );
};

export default OfficeDropdown;
